import { GET_COMPANY_META_DATA_REQUEST, GET_COMPANY_META_DATA_SUCCESS, GET_COMPANY_META_DATA_FAILURE, GET_COMPANY_META_DATA_RESET, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getCompanyMetaDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_COMPANY_META_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_COMPANY_META_DATA_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case GET_COMPANY_META_DATA_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case GET_COMPANY_META_DATA_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default getCompanyMetaDataReducer;
